import type { Partner } from '~/store/services/PartnerService/types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const partners = {
  search: {
    queryKey: 'partner-management-service/partners',
    configurationType: 'cached' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<Partner[]>('/partner-management-proxy/api/v1/partners');
      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/partners/id',
    configurationType: 'no-cache' as const,
    fn: async (partnerId: string) => {
      const { data } = await GatewayAxiosClient.get<Partner>(`/partner-management-proxy/api/v1/partners/${partnerId}`);

      return data;
    },
  },
  update: async ({ partnerId, payload }: { partnerId: string; payload: Partial<Partner> }) => {
    const { data } = await GatewayAxiosClient.put<Partner>(
      `/partner-management-proxy/api/v1/partners/${partnerId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/partners'],
        ['partner-management-service/partners/id', partnerId],
      ],
    };
  },
};
